module.exports = __webpack_public_path__ + "static/enveloop-studio-og.40fbb2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/enveloop-studio-og.png
// module id = 230
// module chunks = 35783957827783